import Vue from 'vue';
import _ from 'lodash'
import {store} from "./store-init";

let portfolioFetchBy = (hash) => {
    const catalog = store.getters.catalogPortfolioContent;
    if(!catalog.length) return [];
    const items = _.filter(catalog, ( item ) => { return item.hash.trim().toLowerCase() === hash.toLowerCase() });
    console.log('portfolioFetchBy', hash, items);
    return items.length ? items : [];
}

Vue.filter('portfolioFetchBy', portfolioFetchBy);